import { gql } from "@apollo/client";

const GET_DASHBOARD_AGENT_SUBSCRIPTION = gql`
  subscription dashboardusers {
    dashboardusers {
      loggedIn
      isOnline
      isConnected
      agentId
      username
      picture
      mainSuperAdminId
      managerId
    }
  }
`;

export default GET_DASHBOARD_AGENT_SUBSCRIPTION;
